class SizeModalController {
    constructor(modal) {
        if (!modal) {
            return;
        }
        this.modal = modal;
        this.sizeModalBtn = document.querySelector('.product-page__info-size-btn');
        this.closeBtn = this.modal.querySelectorAll('[data-closed]');
        this.init();
    }

    init() {
        if (this.sizeModalBtn) {
            this.sizeModalBtn.addEventListener('click', () => {
                this.open();
            });
        }
        
        this.closeBtn.forEach((el) => {
            el.addEventListener('click', () => {
                this.close();
            })
        })
    }

    open() {
        this.modal.classList.add('size-modal--open');
    }

    close() {
        this.modal.classList.remove('size-modal--open');
    }
}

(()=> {
    const sizeModal = document.querySelector('.size-modal');
    new SizeModalController(sizeModal);
})();
